import { useNavigate as useRouterNavigate } from 'react-router-dom';

export type NavigateHook = (url: string, state?: unknown) => void;

export const useNavigate = (): NavigateHook => {
    const routerNavigate = useRouterNavigate();
    const navigate = (url: string, state?: unknown) => {
        routerNavigate(url, { state });
    };

    return navigate;
};
